import { createSelector } from 'reselect';
import { inverseCoordinates } from '../utils/geo';

/**
 * Returns field bounds
 * @param {Object} state
 * @return {Array}
 */
export const getFieldBounds = (state) => state.field.boundary.bounds;

/**
 * Returns field boundary
 * @param {Object} state
 * @return {Object}
 */
export const getFieldBoundary = (state) => state.field.boundary;

/**
 * Returns inversed field boundary
 * @param {Object} state
 * @return {Object}
 */
export const getInversedFieldBoundary = createSelector(
  [getFieldBoundary],
  (fieldBoundary) => ({
    ...fieldBoundary,
    coordinates: inverseCoordinates(fieldBoundary.coordinates),
  })
);
